import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-olympic-insight-container',
  templateUrl: './olympic-insight-container.component.html',
  styleUrls: ['./olympic-insight-container.component.scss']
})
export class OlympicInsightContainerComponent {

  /**
   * The number that appears on right.
   *
   * @memberof OlympicInsightContainerComponent
   */
  @Input() number;

  /**
   * The title input.
   *
   * @memberof OlympicInsightContainerComponent
   */
  @Input() title;

  /**
   * The subtitle input.
   *
   * @memberof OlympicInsightContainerComponent
   */
  @Input() subtitle;
  constructor() { }

}
